import Shader from "_src/engine/shader";

import vertText from "_src/shaders/sharpness/sharpness.glslv";
import fragText from "_src/shaders/sharpness/sharpness.glslf";
import Uniform from "_src/engine/uniform";
import {uniformSource, uniformType} from "_src/engine/constants";
import {vec2} from "_src/libs/gl-matrix";
import {screenUtils} from "_src/client/utils";

export default class SharpnessShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);
    this.depthTest = false;
  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms(params) {
    const sharpness = "sharpness" in params ? params.sharpness : 0.3;

    this.uniforms["tDiffuse"]   = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
    this.uniforms["u_sharpness"] = new Uniform(uniformType.FLOAT1, sharpness);
    this.uniforms["u_resolution"] = new Uniform(uniformType.FLOAT2, vec2.create(), uniformSource.SCENE);
  }

  updateSceneUniformValues(scene) {
    const camera = scene.camera;
    const pixelRatio = screenUtils.getPixelRatio();
    vec2.set(this.uniforms["u_resolution"].value, 1/camera.viewport[2]/pixelRatio, 1/camera.viewport[3]/pixelRatio);
  }

  setStrength(strength) {
    this.setUniform("u_sharpness", strength);
  }

}
